import styled, { css } from "styled-components";

export const TableTitleContainer = styled.div`
  font-size: 12px;
  font-weight: 600;
  padding: 16px 0px 16px 24px;

  ${(props) =>
    props.titleMarginLeft &&
    css`
      padding-left: ${props.titleMarginLeft};
    `}
`;

export const TableTitle = styled.p`
  font-size: 14px;
`;

export const TableContainer = styled.div`
  width: 100%;

  .rdt_TableRow button[aria-label="Expand Row"]:disabled,
  .rdt_TableRow button[aria-label="Collapse Row"]:disabled {
    visibility: hidden;
    pointer-events: none;
  }
  background-color: #fff;
  ${(props) =>
    props.marginTop &&
    css`
      margin-top: ${props.marginTop};
    `}

  ${(props) =>
    props.paddingAround &&
    css`
      padding: ${props.paddingAround};
    `}
`;

export const NoDataText = styled.p`
  margin: 16px 0px 32px 0px;
`;
export const NoDataStaff = styled.div`
  margin-top: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-bottom: 150px;
`;
export const NoDataTitle = styled.div`
  font-family: "Inter";
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: rgba(0, 34, 68, 1);
`;
